import 'core-js/modules/es.object.assign.js';
import { __rest } from '../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { TextField as TextField$1, outlinedInputClasses, FormControl } from '@mui/material';
import { styled, css } from '@mui/material/styles';
import { withUtility } from '../../foundation/utils.js';

let _ = t => t,
  _t;
const MuiTextField = styled(TextField$1, {
  shouldForwardProp: prop => prop !== 'focusBorderColor'
})(withUtility(({
  palette
}, props) => css(_t || (_t = _`
      .MuiOutlinedInput-root fieldset {
        border-color: ${0};
      }
      .${0} fieldset {
        border-width: 1px !important;
        ${0}
      }
    `), palette('outline'), outlinedInputClasses.focused, props.focusBorderColor && `border-color: ${props.focusBorderColor} !important;`)));
const TextField = _a => {
  var {
      shrink = undefined,
      size = 'normal',
      margin,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      m,
      marginX,
      marginY,
      mb,
      ml,
      mr,
      mt,
      mx,
      my,
      label,
      labelColor
    } = _a,
    props = __rest(_a, ["shrink", "size", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight", "m", "marginX", "marginY", "mb", "ml", "mr", "mt", "mx", "my", "label", "labelColor"]);
  return jsx(FormControl, Object.assign({
    sx: {
      margin,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      m,
      marginX,
      marginY,
      mb,
      ml,
      mt,
      mr,
      mx,
      my
    },
    fullWidth: props.fullWidth,
    size: size,
    error: props.error,
    disabled: props.disabled
  }, {
    children: jsx(MuiTextField, Object.assign({}, props, {
      sx: {
        '& .MuiFormHelperText-root': {
          marginLeft: 0
        }
      },
      size: size,
      InputLabelProps: {
        shrink: shrink ? true : undefined,
        style: labelColor ? {
          color: labelColor
        } : {}
      },
      label: label
    }))
  }));
};

export { TextField };
